import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { API_URLS } from './constants/urls/api-urls';
import { fcmSubscribeRepository } from './repository/mytm/notification/notification';

const firebaseConfig = {
  apiKey: 'AIzaSyAUi00ns60MbPYvQhKSMMF7r-8vP4aOatU',
  authDomain: 'mytm-d5de2.firebaseapp.com',
  projectId: 'mytm-d5de2',
  storageBucket: 'mytm-d5de2.appspot.com',
  messagingSenderId: '825973919680',
  appId: '1:825973919680:web:001400e965b1db2b7a8225',
  measurementId: 'G-QJZQTNVP46',
};

// Initialize Firebase
initializeApp(firebaseConfig);
const messaging = getMessaging();

export const requestForToken = (isLogin: boolean) => {
  Notification.requestPermission().then(permission => {
    if (!isLogin) return;
    if (permission === 'granted') {
      getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY }).then(currentToken => {
        if (currentToken) {
          fcmSubscribeRepository(API_URLS.FCM_SUBSCRIBE, { token: currentToken });
        }
      });
    }
  });
};

export const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      resolve(payload);
    });
  });
